<div class="flex-col height100p">
    <sm-toolbar>
        <p-splitButton label="Neue Rechnung erstellen" icon="fas fa-plus" [model]="newInvoiceMenuItems" [menuButtonDisabled]="newInvoiceMenuItems?.length <= 1" (onClick)="newInvoice()"></p-splitButton>
        <p-splitButton label="Rechnungen importieren" icon="fas fa-plus" [model]="importMenuItems"></p-splitButton>
        <span class="ml-3 mr-3">Standorte: </span>
        <p-multiSelect appendTo="body" selectionMode="multiple" [styleClass]="'width500'" [options]="locations" [(ngModel)]="selectedLocations" (ngModelChange)="locationFilterChanged()">
        </p-multiSelect>
        <p-checkbox class="ml-3" label="Nur eigene anzeigen" name="showOnlyOwn" binary=true [(ngModel)]="showOnlyOwn" (ngModelChange)="refillTable()"></p-checkbox>
    </sm-toolbar>
    <p-tabView class="flex-item-fill height100p full-height">
        <p-tabPanel header="Rechnungen">
            <sm-table2 class="flex-item-fill height100p" [data]="table" [floatingFilter]=true [allowCellTextSelection]=false (onRowSelect)="rowSelected($event)" (onRowDoubleClicked)="openDocument($event)">
            </sm-table2>
        </p-tabPanel>
        @for (item of importedItems; track item) {
            <p-tabPanel [header]="'Import-Vorschau: ' + item.title">
                <sm-table2 class="flex-item-fill height100p" [data]="item.table" [floatingFilter]=true [allowCellTextSelection]=false (onRowSelect)="rowSelected($event)" (onRowDoubleClicked)="openDocument($event)">
                </sm-table2>
            </p-tabPanel>
        }
    </p-tabView>
</div>
